import {
  CandidateProfileListProps,
  CandidateProfileListType
} from 'modules/candidate-profile/types/CandidateProfileListProps';

export const shouldShowConversation = (props: CandidateProfileListProps) => {
  switch (props.type) {
    case CandidateProfileListType.CANDIDATES_LIST:
    case CandidateProfileListType.ANALYSIS_CANDIDATES_LIST:
    case CandidateProfileListType.ADD_CANDIDATES_TO_TALENT_POOL:
    case CandidateProfileListType.CANDIDATES_FROM_TALENT_POOL:
      return true;
    case CandidateProfileListType.ANALYSIS_CANDIDATES_FROM_TALENT_POOL:
      return false;
  }
};
